import React from 'react';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import './Banner.css';

// Static image imports
import ban1 from '../src/images/ban1.jpg';
import ban2 from '../src/images/ban2.jpg';
import ban3 from '../src/images/ban3.jpg';
import ban4 from '../src/images/ban4.jpg';
import ban5 from '../src/images/ban5.jpg';
import ban6 from '../src/images/ban6.jpg';
import ban7 from '../src/images/ban7.jpg';
import ban8 from '../src/images/ban8.jpg';
import ban9 from '../src/images/ban9.jpg';

// Custom Arrow Components
const CustomPrevArrow = (props) => {
  const { onClick } = props;
  return (
    <button
      className="nd-slider-arrow nd-slider-prev"
      onClick={onClick}
      aria-label="Previous Slide"
    >
      <i className="fa fa-chevron-left"></i>
    </button>
  );
};

const CustomNextArrow = (props) => {
  const { onClick } = props;
  return (
    <button
      className="nd-slider-arrow nd-slider-next"
      onClick={onClick}
      aria-label="Next Slide"
    >
      <i className="fa fa-chevron-right"></i>
    </button>
  );
};

const Banner = () => {
  // Static list of images
  const banners = [
    { imageUrl: ban9 },
    { imageUrl: ban1 },
    { imageUrl: ban2 },
    { imageUrl: ban3 },
    { imageUrl: ban4 },
    { imageUrl: ban5 },
    { imageUrl: ban6 },
    { imageUrl: ban7 },
    { imageUrl: ban8 },
  ];

  const settings = {
    dots: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 5000,
    speed: 700,
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
    pauseOnHover: true,
    nextArrow: <CustomNextArrow />,
    prevArrow: <CustomPrevArrow />,
    customPaging: (i) => <div className="nd-custom-dot"></div>,
    dotsClass: "slick-dots nd-slick-dots"
  };

  return (
    <div className="nd-hero-banner-wrapper">
      <div className="nd-banner-container">
        <Slider {...settings}>
          {banners.map((banner, index) => (
            <div key={index} className="nd-slide-item">
              <div className="nd-image-card">
                <img
                  src={banner.imageUrl}
                  alt={`ND Connect Banner ${index + 1}`}
                  className="nd-banner-img"
                />
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default Banner;
